import type { FaireProductEntity } from "../../entity_types/product";

export const p_94a977w7pk: FaireProductEntity = {
  token: "p_94a977w7pk",
  type: "product",
  name: "Easily Distracted By Snacks Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/736cc9909a814e28c3803f1c2c268dad6f044d74cb877fc7a963e861cd0c4bbf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bedd86fe106841be1d8053a0ea2e120f1053bfa2b5705e03b5c51712d9c797a5.jpeg",
    "https://cdn.faire.com/fastly/397450284841121ce60f98b4dc55a200e559b93fd9041d76208af04138692669.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/ea398e6ae97bfaead5200d79690555228eb15d519644a3ba33b264f0ee7a6dfb.jpeg",
    "https://cdn.faire.com/fastly/f298680ac3aeb1647fef6df9d259c08d8839c136909c9e6f82de794c201f5425.jpeg",
    "https://cdn.faire.com/fastly/8a9a5f7622554251459d3361f66e65756d8deb5294c91b4d57bb1359870c34d2.jpeg",
    "https://cdn.faire.com/fastly/ccb0efd95b3526f87720cf4de2038e1d036ae0a6e2f7e2a19120fd04af1084fe.jpeg"
  ],
  priceDollars: 6.75,
  description: "All bets are off when the little treats show up. These socks serve as fair warning - everything comes second to snacks. 😋\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:24.193Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
